
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import services from "../data/services";
import "../styles/about.css";

export default function About() {
  const itemsRef = useRef([]);
  const navigate = useNavigate();

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("show");
          }
        });
      },
      { threshold: 0.3 }
    );

    itemsRef.current.forEach((el) => el && observer.observe(el));
    itemsRef.current.forEach((el) => el && el.classList.add("show"));

    return () => observer.disconnect();
  }, []);

  const handleNavigate = (id) => {
    navigate(`/service/${id}`);
    window.scrollTo(0, 0);
  };

  return (
    <section id="about" className="about-section">

      {services.map((item, index) => (
        <div
          key={index}
          ref={(el) => (itemsRef.current[index] = el)}
          className={`about-block ${index % 2 === 0 ? "normal" : "reverse"}`}
        >
          <div className="about-text">
            <h2>{item.title}</h2>
            <span className="highlight">{item.highlight}</span>
            <p>{item.desc}</p>

            <button
              className="learn-btn"
              onClick={() => handleNavigate(item.id)}
            >
              {item.buttonLabel || "View Details"}
            </button>
          </div>

          <div className="about-image">
            <img src={item.image} alt={item.title} />
          </div>
        </div>
      ))}
    </section>
  );
}
